export const parser = (data: string = '') => {
  const paragraphs = data?.split('\n\n') || [];

  // wrap last paragraph with quote

  let lastParagraph = paragraphs.pop();

  lastParagraph = `*“${lastParagraph}”*`;

  paragraphs.push(lastParagraph);

  return paragraphs.join('\n\n');
};
